export const EMIRATES_ID_AUTH_MESSAGES = {
  SIGN_IN_FAILED: "Failed to sign in with Emirates ID",
  MISSING_TRANSACTION_ID: "Missing transactionId in response",
  MISSING_OTP_TOKEN: "Missing jwtToken in send OTP response",
  OTP_SENT_SUCCESS: "OTP was sent successfully!",
  LOGIN_SUCCESS: "Login successful!",
  SMS_OTP_SEND_FAILED: "Failed to send SMS OTP",
  SMS_OTP_RESEND_FAILED: "Failed to resend SMS OTP",
  SMS_OTP_VERIFY_FAILED: "Failed to verify SMS OTP",
  EMAIL_OTP_SEND_FAILED: "Failed to send Email OTP",
  EMAIL_OTP_RESEND_FAILED: "Failed to resend Email OTP",
  EMAIL_OTP_VERIFY_FAILED: "Failed to verify Email OTP",
  GENERIC_ERROR: "An error occurred",
};
